<template>
    <div class="g-content g-autofixheight order order-contribute" v-loading="saveLoading">
        <div class="contribution-page">
            <div class="contribution">
                <!-- 编辑区域 -->
                <div class="complie">
                    <div class="header">
                        <i class="ico ico-step1"></i>
                        <div class="tag">编辑内容</div>
                        <!-- 选项卡，点击切换内容 start -->
                        <div class="g-tab">
                            <a href="javascript:;" v-for="(item,index) in tabList" :key="index" @click="changeTab(index,item)">
                                <div class="g-tab-item" :class="{'g-tab-item-active': index == curTab}">{{item.name}}</div>
                            </a>
                            <!--<router-link class="g-tab-item" active-class="g-tab-item-active" :to="{name: 'v4-order-content-create'}">图文投稿</router-link>-->
                            <!--<router-link class="g-tab-item" active-class="g-tab-item-active" :to="{name: 'v4-order-supplier'}">视频</router-link>-->
                        </div>
                        <!-- 选项卡，点击切换内容 end -->
                    </div>
                    <!-- 图文内容可编辑区域[[ -->
					<game-list ref="gameList" @gameChange="choiceGame" style="width:900px;margin: 0 auto;"></game-list>
					<Content-Create ref="contentCreate" v-show="curTab != 1"
									:title.sync="params.title"
					>
					</Content-Create>
                    <!-- 图文内容可编辑区域]] -->

                    <!-- 视频内容可编辑区域[[ -->
                        <!-- <Video-Create ref="videoCreate" v-show="curTab == 1"
                                      @addfile="addVideoFile"
                                      @delVideo="delVideo"
                                      @completed="videoCompleted"
                                      @updateVidInfo="updateVidInfo"
                                      @videoTypeChange="videoTypeChange"
                                      :video-id.sync="params.video_id"
                                      :vid.sync="params.vid"
                                      :title.sync="params.title"
                                      :video-name="params.videoName"
									  :duration.sync="params.duration"
					></Video-Create> -->
					<video-create-cloud ref="videoCreate" v-show="curTab == 1"
									@delVideo="delVideo"
									@completed="videoCompleted"
									@updateVidInfo="updateVidInfo"
									@videoTypeChange="videoTypeChange"
									:video-id.sync="params.video_id"
									:vid.sync="params.vid"
									:title.sync="params.title"
									:video-name="params.videoName"
									:duration.sync="params.duration"
					></video-create-cloud>
				<!-- 视频内容可编辑区域]] -->

					<BasicForm ref="basicForm"
								:curGameId="demandItemInfo.gameId"
								:defaultParams.sync="basicFormParams"
								:summary.sync="params.summary"
								:tags.sync="params.tags"
								:theme_id.sync="params.theme_id"
								:kol.sync="params.kol"
								:covers.sync="params.covers"
								:author.sync="params.author"
								:keywords.sync="params.keywords">
					</BasicForm>
                </div>

                <!-- 发布渠道[[ -->
                <div class="publish">
                    <div class="header">
                        <i class="ico ico-step2"></i>
                        <div class="tag">发布渠道</div>
                    </div>
                    <div class="edit-content">
                        <!-- 全部渠道-多选 -->
                        <tgl-channel
							:game-id.sync="demandItemInfo.gameId"
							:channel-ids.sync="params.channelIds"
							:labels.sync="tglChannelDialog.realChannelLabels"
							ref="tglChannel"
							:hasQQChannel.sync="hasQQChannel">
                        </tgl-channel>
                        <media-distribute
							:curGameId="demandItemInfo.gameId"
							:medias.sync="params.medias"
							:defaultSelectedMediaList="mediaDistributeData.selectedMediaList"
							:covers.sync="params.covers"
							:contentType="getContentType"
							:isVidDistribute="getVideoTypeStatus"
							:hasVideoId="hasVideoId"
							ref="tglMediaDistribute">
                        </media-distribute>
                    </div>
                    <div class="footer-bar">
                        <div class="footer-bar-btn">
                            <div class="g-bottom-btn btn-group">
                                <a class="button js-cancel-btn" href="javascript:;" @click="cancelContribute">取消</a>
                                <!-- 预览按钮，点击显示预览弹窗 start -->
                                <!-- <a class="button preview-btn" href="javascript:;" @click="preview">预览</a> -->
                                <!-- 预览按钮，点击显示预览弹窗 end -->
                                <a class="button" href="javascript:;" @click="saveDraft">存草稿</a>
                                <a class="button bg-btn" href="javascript:;" @click="saveContribute">发布</a>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 发布渠道]] -->
                <!--内容预览 start-->
                <content-preview ref="contentPreview"></content-preview>
                <video-preview ref="videoPreview"></video-preview>
                <!--内容预览 end-->
            </div>
        </div>
    </div>
</template>
<style  lang="scss" scoped>
    @import  '~Assets/sass/pages/v4/order/contribution.scss';
    @import  '~Assets/sass/pages/v4/order/order.scss';
    @import '~Assets/sass/pages/v4/order/order_contribute.scss';
    .go-back-btn{
        float: right;
        background-color: #fff;
        color: #FD7E28;
        vertical-align: top;
        width: auto;
        height: 30px;
        margin: 0 25px;
        padding: 0 30px;
        border: 1px solid #FD7E28;
        border-radius: 2px;
        line-height: 30px;
        font-size: 14px;
    }
    p.tougao-tit{width: 100%}
</style>
<script>
import ContentCreate from './content_create';
// import VideoCreate from './video_create';
import gameList from 'Components/v4/dropdown/gamelist_v4';
import VideoCreateCloud from './video_create_cloud';
import BasicForm from './basic_form';
import tglChannel from '../tgl_channel';
import mediaDistribute from '../media_distribute';
import contentPreview from 'Components/v4/pop/content_preview';
import videoPreview from 'Components/v4/pop/video_preview';
import {
    ArticlesV3Detail, ArticlesV3Video, ArticlesV3Text, ContributeText, ContributeVideo, ContributeNovel, ContributeCartoon, AuthorOrderInfo, DemandArticleDetails, PersonDemandItemInfo, SupplierDemandInfo 
} from 'Services/getData.js';
import store from 'Stores';
export default {
    name: 'order_contribute.vue',
    data() {
        return {
            saveLoading: false,
            curTab: 0,
            tabList: [
                {
                    name: '图文内容', id: 0, isActive: true, curTab: 0
                },
                {
                    name: '视频内容', id: 1, isActive: true, curTab: 1
                },
                {
                    name: '小说内容', id: 50, isActive: true, curTab: 2
                },
                {
                    name: '漫画内容', id: 60, isActive: true, curTab: 3
                }
            ],
            demandItemInfo: {
                gameId: null,
	                gameLogo: '',
	                demandItemName: '',
                gameName: '',
	                approverProve: '' // 说明
            },
            demandInfo: {}, // 保存需求单信息详情
            params: {
                is_save: 0,
                id: '', // article id
                channelIds: [],
                order_id: '', // 订单id：个人明细项id或者作者订单id
                theme_id: '', // 1：教学；2：赛事；3： 同人；4：娱乐；5：资讯
                game_id: '',
                kol: '', // 只有王者需要，是什么鬼？
                author: '', // 作者昵称
                type: 0, // 0：图文；1：视频；2：图集；50：小说；60：漫画
                title: '',
                content: '', // 内容详情
                summary: '', // 简介
                covers: [], // 封面附件id集合
                tags: '', // 内容标签，
                keywords: '', // "3108,3107"
                medias: [], // 媒体分发数据
                video_id: '',
                vid: '',
                duration: '',
                videoName: '',
                qcloudFileId: ''
            },
            basicFormParams: {
                theme_id: '', // 1：教学；2：赛事；3： 同人；4：娱乐；5：资讯
                kol: '', // 只有王者需要，是什么鬼？
                author: '', // 作者昵称
                // content: '',// 内容详情
                summary: '', // 摘要
                covers: [], // 封面附件id集合
                tags: '', // 内容标签，
                keywords: '',
                gameId: ''
            },
            tglChannelDialog: {
	                realChannelIds: []
            },
            hasQQChannel: false,
            authorOrderInfo: {},
            ableLeaveDirectly: false, // 是否允许直接离开
            articleInfo: {}, // 用于保存内容详情，编辑用
            mediaDistributeData: {
                gameId: 0,
	                selectedMediaList: []
            },
            contributeType: '', // 决定跳转出口，默认后退
            routeNameList: {
                'demand': 'v4-order-supplier-detail-pugc', // query-> demandId
                'authorOrder': 'v4-order-related-author-charge', // query -> id
                'personContent': 'v4-order-person-content-detail', // query->id
                'personService': 'v4-order-person-content-detail' // query->id
            },
            edit_times: 0,
            total_sec: Date.now()
        }
    },
    created() {
        // let {articleId, demandId, authorOrderId, demandItemId} = this.$route.query;
        let articleId = this.$route.query.id;
	        if(articleId){   // 内容编辑
            this.getDemandArticleDetails(articleId).then(()=>{
                this.params.draftId = this.articleInfo.articleId;
                this.params.gameId = this.articleInfo.gameId;
                if(this.articleInfo.gameId){
                    this.$refs.gameList.syncGameInfoWithId(this.articleInfo.gameId);
                }
	                // this.demandItemInfo.gameId = this.articleInfo.gameId;
	                // let { demandId, demandItemId} = this.articleInfo;
	                // if(demandId > 100000){ // 供应商订单
		            //     this.getAuthorOrderInfo(demandItemId).then(()=>{
			        //         let {gameName ,cycle_explain, order_name, logoUrl,game_id} = this.authorOrderInfo;
			        //         this.demandItemInfo.gameLogo = logoUrl;
			        //         this.demandItemInfo.demandItemName = order_name;
			        //         this.demandItemInfo.gameName = gameName;
			        //         this.demandItemInfo.gameId = game_id;
			        //         this.demandItemInfo.approverProve = cycle_explain;
			                this.fillArticleData();
                //     });
                // }else{  // 个人外团派单，拉取需求明细项信息
		            //     this.getPersonDemandItemInfo(demandItemId).then(()=>{
			        //         this.fillArticleData();
                //     });
                // }
            });
        }
        // }else{ // 新增
        //     if(demandId) { // 供应商需求单 PUGC/PGC投稿, 需要提供demandId, authorOrderId两个参数,内容跟需求单下的作者订单关联
	        //         this.contributeType = "demand";
	        //         this.getDemandInfo(demandId).then(() => {
		    //             this.params.game_id = this.demandItemInfo.gameId;
		    //             this.params.order_id = this.demandInfo.authorOrderId;
	        //         });
        //     }else if(authorOrderId) {
	        //         this.contributeType = "authorOrder";
	        //         this.params.order_id = authorOrderId;
	        //         this.getAuthorOrderInfo(this.params.order_id).then(() => {
		    //             let { gameName, cycle_explain, order_name, logoUrl, game_id } = this.authorOrderInfo;
		    //             this.demandItemInfo.gameLogo = logoUrl;
		    //             this.demandItemInfo.demandItemName = order_name;
		    //             this.demandItemInfo.gameName = gameName;
		    //             this.demandItemInfo.gameId = game_id;
		    //             this.demandItemInfo.approverProve = cycle_explain;
		    //             this.params.game_id = game_id;
	        //         });
        //     }else if(demandItemId) { // 个人外团派单投稿
	        //         this.params.order_id = demandItemId;
	        //         this.getPersonDemandItemInfo(demandItemId).then(()=>{
		    //             this.params.game_id = this.demandItemInfo.gameId;
		    //             if(this.demandItemInfo.demandType == 10){
        //                 this.contributeType = 'personContent';
        //             }else{
        //                 this.contributeType = 'personService';
        //             }
        //         });
		    //     }else{
        //         this.$router.go(-1);
		    //     }
        // }
    },
    mounted() {

    },
    components: {
        ContentCreate,
        BasicForm,
        tglChannel,
        mediaDistribute,
        contentPreview,
        videoPreview,
        VideoCreateCloud,
        gameList
    },
    methods: {
        choiceGame(game){
            this.demandItemInfo.gameId = game.id;
            if(game){
                this.params.game_id = game.id;
            }else{
                this.params.game_id = '';
            }
        },
	        goBack() {
            this.$confirm('系统可能不会保存您所做的更改', '要离开当前页面么', {
                'confirmButtonText': '确认', cancelButtonText: '取消' 
            })
                .then(() => {
                    this.ableLeaveDirectly = true;
                    this.$router.go(-1);
                }).catch(() => {});
        },
	        changeTab(index, item){
	        	if(!this.isParamsChange){
			        this.params.type = item.id;
                this.curTab = index;
			        return;
            }
		        this.$confirm('系统可能不会保存您所做的更改', '要离开当前页面么', {
                'confirmButtonText': '确认', cancelButtonText: '取消' 
            })
			        .then(() => {
				        this.curTab = index;
				        this.params.type = item.id;
				        this.resetPage();
			        }).catch((e) => {
			        console.log(e);
                });
	        },
        resetPage() {
	            this.params.id = '';
            this.params.is_save= 0;
	            this.params.channelIds=[];
	            this.params.theme_id= '';
	            this.params.kol= '';
	            this.params.author= '';
	            this.params.title= '';
	            this.params.content= '';
	            this.params.summary='';
	            this.params.covers= [];
	            this.params.tags= '';
	            this.params.keywords= '';
	            this.params.medias= [];
	            this.params.video_id= '';
	            this.params.videoName= '';
            this.params.vid= '';
            this.params.duration= '';
            this.$refs.basicForm.resetParam();
	            this.$refs.contentCreate.fillForm({
                articleTitle: '', articleContent: ''
            });
            this.$refs.tglMediaDistribute.resetParam(this.params.game_id);
            // 更新store
        },
        fillArticleData () {
	            let {
                articleTitle, articleId, articleStatus, articleType, gameId, vid, videoId, videoImg,
		            kolRelation, creator, author, demandItemId, demandId, summary, articleContent, themeId, hourLong,
                attachments, mediaDistribute, tags, keywords, channelIds, videoName, qcloudFileId
            } = this.articleInfo;
	            // this.$refs.basicForm.fillForm({kolRelation, author,summary});
	            this.basicFormParams = {
		            theme_id: themeId,
		            kol: kolRelation,
		            author,
		            summary,
		            covers: attachments,
		            tags: tags,
		            keywords: keywords,
                gameId
            };
            this.params.id=articleId;
	            this.params.title= articleTitle;
	            this.params.theme_id= themeId;
            this.params.author= author;
            this.params.type= articleType;
            this.params.order_id= demandItemId;
            this.params.game_id = gameId;
	            this.params.content= articleContent;
            this.params.summary= summary;
            this.params.qcloudFileId = qcloudFileId;
	            if(articleStatus == 0 ){
		            this.params.is_save= 0;
            }
	            this.params.kol= kolRelation;
            this.params.channelIds= channelIds;
	            this.params.keywords= keywords;
            this.resetMediaDistributeInfo(mediaDistribute, gameId);
	            //this.params.covers = [];
	            //this.params.tags= [];

            if(articleType== 1){
		            this.curTab = 1;
		            this.params.video_id= videoId;
                this.params.vid= vid;
                this.params.duration = hourLong;
	                this.params.videoName = videoName;
            }else if(articleType == 50){
	                this.curTab = 2;
	                this.$refs.contentCreate.fillForm({
                    articleTitle, articleContent
                });
            }else if(articleType == 60){
		            this.curTab = 3;
	                this.$refs.contentCreate.fillForm({
                    articleTitle, articleContent
                });
            }else{
		            this.curTab = 0;
	                this.$refs.contentCreate.fillForm({
                    articleTitle, articleContent
                });
            }

        },
        resetMediaDistributeInfo(mediaDistribute, gameId = 0) { // 变量名称映射
	            this.params.medias = [];
	            this.mediaDistributeData.gameId = gameId;
	        	if(mediaDistribute && mediaDistribute.length){
			        this.mediaDistributeData.selectedMediaList = [];
	        		mediaDistribute.filter((mediaInfo)=>{
	        			let {
                        accountId, media, outCover, outCoverExtra, outDesc, outTags, outTitle, outCategory, mediaId, accountName, mediaLogo
                    } = mediaInfo;
				        let tags = JSON.parse(outTags);
				        let tagIds = [];
				        let tagNames = [];
				        tags.filter((tag)=>{
					        tagIds.push(parseInt(tag.id));
					        tagNames.push(tag.name);
                    });
				        let wxCategory = [];
				        if(media== 'wx'){   // 微信游戏圈的分类值是数组，单独处理
					        outCategory = outCategory.split(',');
					        outCategory.filter((id)=>{
						        wxCategory.push(parseInt(id));
                        });
					        outCategory = wxCategory;
                    }
				        this.mediaDistributeData.selectedMediaList.push(
				        	{
						        logo: mediaLogo,
                            enName: media,
                            name,
                            accountId,
                            currentAccountName: accountName,
                            category: outCategory,
                            title: outTitle,
                            summary: outDesc,
                            cover: outCover,
                            tags: tagIds,
                            coverExtra: outCoverExtra,
                            gameId
				        	}
                    );
                })
            }
        },
        saveDraft() {
	            if(!this.validateParams()){
		            return false;
            }
            if(this.saveLoading == true){
                this.$alert('操作频繁');
                return false;
            }
            this.saveLoading = true;
            this.params.is_save = 1;
	            switch (this.curTab){
		            case 0:
		            case 2:
		            case 3:
			            this.doSaveContent();
			            break;
		            case 1:
			            this.doSaveVideo();
			            break;
            }
            this.saveLoading = false;
        },
	        saveContribute() {
            this.edit_times++;
		        if(!this.validateParams()){
			        return false;
            }
            if(this.saveLoading == true){
                this.$alert('操作频繁');
                return false;
            }
            this.saveLoading = true;
		        this.params.is_save = 0;
		        switch (this.curTab){
			        case 0:
			        case 2:
			        case 3:
				        this.doSaveContent();
				        break;
			        case 1:
				        this.doSaveVideo();
				        break;
            }
	        },
        updateFormParam(param) {
	            Object.assign(this.params, param);
        },
	        validateParams() {  // 参数检查
		        let pass = true;
		        if(this.curTab != 1){
			        let contentCmp = this.$refs.contentCreate;
			        this.updateFormParam(contentCmp.getParams());
            }
		        let {
                title, content, tags, keywords, author, theme_id, covers, kol, game_id, summary 
            } = this.params;
            if(title.length < 10){
			        this.$alert('标题至少10个字符~');
			        return false;
            }
            if(!summary){
			        this.$alert('简介不能为空~');
			        return false;
            }
            if(summary.length > 50 || summary.length < 5){
	                this.$alert('简介需要5~50个字符');
	                return false;
            }
            if(!tags.length){
			        this.$alert('请选择标签~');
			        return false;
            }else{
	                let tagsArr = tags.split(',');
                	if(tagsArr.length > 9 || tagsArr.length < 2){
		                this.$alert('请选择2~9个标签~');
		                return false;
                }
            }
            if(!keywords){
			        this.$alert('请选择关键词~');
			        return false;
            }else{
	                let keywordsArr = keywords.split(',');
	                if(keywordsArr.length > 9 || keywordsArr.length < 2){
		                this.$alert('请选择2~9个关键词~');
		                return false;
	                }
            }
            if(!author){
	                this.$alert('作者不能为空~');
	                return false;
            }
            if(!covers[0]){
	                this.$alert('请上传封面图~');
	                return false;
            }
		        if(!theme_id){
			        this.$alert('题材不能为空~');
			        return false;
		        }
		        // if(this.params.game_id == 362 && !kol){
			     //    this.$alert('请选择KOL相关~');
			     //    return false;
            // }
            let hasQQ = false;
            this.params.medias.filter( (item) => {
                if(item.enName == 'qq'){
                    hasQQ = true;
                }
            })
            if(this.hasQQChannel && !hasQQ){
	                this.$alert('因为渠道中勾选了手Q游戏中心，需要在个人账号中选择手Q游戏中心账号！');
	                return false;
            }

            if(this.params.is_save){ // 草稿
                if(!this.params.title){
	                    pass = false;
	                    this.$alert('请填写标题~');
	                    return false;
                }
            }else{
                	if(this.curTab == 1){   // 视频
                    if(!this.params.video_id && !this.params.vid){
	                        this.$alert('请上传视频或填写视频vid~');
	                        return false;
                    }
                    if(!this.params.duration){
	                        this.$alert('请填写视频时长');
	                        return false;
                    }
                }else{  // 图文
		                if(!content.length){
			                this.$alert('内容不能为空~');
			                return false;
		                }
                }
            }
            for(let media of this.params.medias){
	                if(media.enName == 'kandian'){
	                	if(!media.cover){
			                this.$alert('请上传看点封面图~');
			                pass = false;
			                break;
                    }
                    if(!media.category){
			                this.$alert('请选择看点分类~');
			                pass = false;
			                break;
                    }
	                }
	                if(media.enName == 'wx'){
		                if(!media.cover){
			                this.$alert('请微信游戏圈封面图~');
			                pass = false;
			                break;
		                }
		                if(!media.category){
			                this.$alert('请选择微信游戏圈分类~');
			                pass = false;
			                break;
		                }
	                }
	                if(media.enName == 'qq'){
                    console.log(media)
		                if(!media.cover){
			                this.$alert('请上传手Q封面图~');
			                pass = false;
			                break;
                    }
                    if(!media.coverExtra){
                        this.$alert('请上传手Q推荐图~');
			                pass = false;
			                break;
                    }
		                if(!media.category){
			                this.$alert('请选择手Q分类~');
			                pass = false;
			                break;
		                }
	                }
            }
		        return pass;
        },
	        videoCompleted(result){
            this.params.video_id = result.videoId;
            this.params.qcloudFileId = result.qcloudFileId;
            this.params.videoName = result.fileName;
	        },
	        updateVidInfo(vidInfo) { // 暂时拉取不到封面图
		        // this.$refs.basicForm.setCommonPic();
        },
        videoTypeChange() {
	            this.$refs.tglMediaDistribute.resetParam(this.params.game_id);
        },
	        delVideo() {
		        this.params.video_id = '';
        },
        formatSaveParams() {
	            let param = {};
	            Object.assign(param, this.params);
	            let coverIds = [];
	            let channelIds = [];
	            this.params.covers.filter((v) => {
		            if (v){
			            coverIds.push(v)
                }
	            });
	            this.params.channelIds.filter((v) => {
		            if (v){
			            channelIds.push(v)
		            }
	            });
	            param.medias = JSON.stringify(this.params.medias);
	            param.covers = coverIds.join(',');
            param.channelIds = channelIds.join(',');
	            return param;
        },
	        goBackDetailPage() {
		        // if(!this.contributeType){
			    //     this.$router.go(-1);
            // }else{
			    //     let path = this.routeNameList[this.contributeType];
			    //     let query = {};
	        	// 	switch (this.contributeType) {
            //         case  'demand':
	            //            query= {demandId: this.demandInfo.id};
	            //             break;
            //         case  'authorOrder':
            // 	        query= {id: this.authorOrderInfo.id};
            // 	        break;
            //         case  'personService':
            //         case  'personContent':
            // 	        query= {id: this.demandItemInfo.id};
            // 	        break;
            //     }
	        	// 	if(!path){
            //         this.$router.go(-1);
            //     }else{
	        	// 		this.$router.history.push({'name': path, query: query})
            //     }
            // }
            this.$router.push({
                name: 'v3-manage'
            })
        },
	        async doSaveContent(){
            let reqStartTime = Date.now();
            let response = null;
				
            response = await ArticlesV3Text(this.formatSaveParams());
	        	// if(this.curTab === 0){
			    //     response = await ContributeText(this.formatSaveParams());
            // }else if(this.curTab === 2) {
			    //     response = await ContributeNovel(this.formatSaveParams());
            // }else if(this.curTab === 3) {
			    //     response = await ContributeCartoon(this.formatSaveParams());
            // }
            if(this.formatSaveParams().is_save == 0){
                this.$common.reportContribute(
                    response.data.code == 0 ? 1 : 0,
                    response.data.info,
                    this.edit_times,
                    'order',
                    reqStartTime,
                    this.total_sec,
                );
            }
            if(response.status != 200){
	                this.saveLoading = false;
	                return false;
            }
		        this.saveLoading = false;
		        let result = response.data;
		        if(result.code === 0){
			        this.$message({
                    type: 'success',
				        duration: 1000,
				        showClose: true,
				        dangerouslyUseHTMLString: true,
				        message: '<h2>操作成功~</h2>'
			        });
			        this.ableLeaveDirectly = true;
			        if(!this.params.is_save){
				        setTimeout(()=>{
					        this.goBackDetailPage();
				        }, 1000);

                }else{// 停留当前页面
                    	this.params.id = result.data;
                }
		        }
	        },
	        async doSaveVideo(){
            let reqStartTime = Date.now();
            let response = await ArticlesV3Video(this.formatSaveParams());
            if(this.formatSaveParams().is_save == 0){
                this.$common.reportContribute(
                    response.data.code == 0 ? 1 : 0,
                    response.data.info,
                    this.edit_times,
                    'order',
                    reqStartTime,
                    this.total_sec,
                );
            }
		        this.saveLoading = false;
		        let result = response.data;
		        if(result.code === 0){
			        this.ableLeaveDirectly = true;
			        this.$message({
                    type: 'success',
				        duration: 1000,
				        showClose: true,
				        dangerouslyUseHTMLString: true,
				        message: '<h2>操作成功~</h2>'
			        });
			        if(!this.params.is_save){
				        setTimeout(()=>{
					        this.goBackDetailPage();
				        }, 1000);
                }else{// 停留当前页面
				        this.params.id = result.data;
			        }
		        }
	        },
        cancelContribute() {
	            this.$confirm('系统可能不会保存您所做的更改', '要离开当前页面么', {
                'confirmButtonText': '确认', cancelButtonText: '取消' 
            })
                .then(() => {
                    this.ableLeaveDirectly = true;
                    this.$router.go(-1);
                }).catch(() => {});
        },
        preview() {
	        	if(!this.params.title){
			        this.$alert('标题必须填写~');
			        return false;
            }
	            if(this.curTab != 1){ // 拉取富文本内容
		            let contentCmp = this.$refs.contentCreate;
		            this.updateFormParam(contentCmp.getParams());
	            }
	            if(this.curTab === 1){ // 视频预览
		            let {
                    title, video_id, author, summary, vid, qcloudFileId
                }= this.params;
		            let articleInfo = {
                    articleTitle: title, creator: author, summary, videoId: video_id, vid, qcloudFileId
                };
                this.$refs.videoPreview.contributeInfo(articleInfo);
	            }else{
                let {
                    title, content, author, summary
                } = this.params;
                let articleInfo = {
                    articleTitle: title, articleContent: content, creator: author, summary
                };
                this.$refs.contentPreview.contributeInfo(articleInfo);
            }
        },
	        async getAuthorOrderInfo(authorOrderId) {
		        let res = await AuthorOrderInfo({
                authorOrderId
            });
		        if(res.status === 200 && res.data.code == 0){
			        if(res.data.code == 0){
				         this.authorOrderInfo = res.data.data;
			        }
		        }
	        },
	        async getPersonDemandItemInfo(demandItemId) {
		        let res = await PersonDemandItemInfo({
                demandItemId
            });
		        if(res.status === 200 && res.data.code == 0){
			        if(res.data.code == 0){
				        let data = res.data.data;
				        this.demandItemInfo = data;
			        }
		        }
	        },
        async getDemandArticleDetails(id) {
		        let res = await ArticlesV3Detail({
                id
            });
		        if(res.status === 200 && res.data.code == 0){
			        if(res.data.code == 0){
			        	this.articleInfo = res.data.data;
			        }else{
				        this.$router.go(-1);
                }
		        }
	        },
	        async getDemandInfo(demandId) {
		        let res = await SupplierDemandInfo({
                demandId: demandId
            });
		        if(res.status === 200 && res.data.code == 0) {
			        let data = res.data;
			        if (data.code == 0) {
				        let {
                        logoUrl, demand_name, gameName, game_id, produce_desc 
                    } = data.data;
				        this.demandInfo = data.data;
				        this.demandItemInfo = {
                        gameLogo: logoUrl, demandItemName: demand_name, gameName, approverProve: produce_desc, gameId: game_id
                    };
			        }
		        }
	        }
    },
    computed: {
        isParamsChange() {
            let hasBeenEdit = false;
            let arrKey = ['channelIds', 'kol', 'author', 'content', 'theme_id', 'video', 'vid', 'keywords', 'medias', 'tags', 'title', 'type'];
            for (let [k, v]  of Object.entries(this.params)) {
                if(arrKey.includes(k) && v && v.length){
	                    hasBeenEdit = true;
                }
            }
            return hasBeenEdit;
        },
        getContentType() {
            let typeList = {
                0: 'article', 1: 'video', 2: 'novel', 3: 'cartoon' 
            }
	            return typeList[this.curTab];
        },
        getVideoTypeStatus() {
            return this.params.vid.length ? 1 : 0;
        },
        hasVideoId () {
	            return this.params.video_id ? 1 : 0;
        }
    },
    watch: {
        "params.title": (nVal, oVal) =>{
            store.commit('setMediaDistributeData', {
                title: nVal 
            });
        },
        "params.summary": (nVal, oVal) =>{
            store.commit('setMediaDistributeData', {
                summary: nVal 
            });
        },
        "params.tags": (nVal, oVal) =>{
            store.commit('setMediaDistributeData', {
                tags: nVal 
            });
        },
        "params.keywords": (nVal, oVal) =>{
            store.commit('setMediaDistributeData', {
                keywords: nVal 
            });
        }
        // hasQQChannel(val,oldVal){
        // 	this.$refs.tglMediaDistribute.selectedMedia(1,2);
        // },
    },
    beforeRouteLeave (to, from, next) { // 组件内容导航守卫
        if(!this.isParamsChange){
	            return next();
        }else if(this.ableLeaveDirectly){
	            return next();
        }else {
	            this.$confirm('系统可能不会保存您所做的更改', '要离开当前页面', {
                'confirmButtonText': '确认', cancelButtonText: '取消' 
            })
		            .then(() => {
			            return  next()
		            }).catch((e) => {
		            console.log(next);
		            console.log(e)
	            });

        }
    }
}
</script>


